import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';

export enum CarteiraDocumentosState {
  LISTA = 'LISTA',
  SELECIONAR_DOCUMENTO = 'SELECIONAR_DOCUMENTO',
  UPLOAD_DOCUMENTO = 'UPLOAD_DOCUMENTO',
  PREVIEW_IMAGEM = 'PREVIEW_IMAGEM',
  VISUALIZAR_DOCUMENTO = 'VISUALIZAR_DOCUMENTO',
}

export interface CarteiraDocumentosData {
  state: CarteiraDocumentosState;
  integranteId: string | null;
  integranteNome: string | null;
  cpfIntegrante: string | null;
  tiposDocumentoExistentes: string[];
  tipoDocumento: string | null;
  nomeDocumento: string | null;
  imagemSrc: string | null;
  isPdf: boolean;
  dataEnvio: string | null;
  referenciaDocumento: string | null;
  idDocumento: number | null;
  documentoIncluidoComSucesso: boolean;
  documentoExcluidoComSucesso: boolean;
  erroInclusao: string | null;
}

const initialState: CarteiraDocumentosData = {
  state: CarteiraDocumentosState.LISTA,
  integranteId: null,
  integranteNome: null,
  cpfIntegrante: null,
  tiposDocumentoExistentes: [],
  tipoDocumento: null,
  nomeDocumento: null,
  imagemSrc: null,
  isPdf: false,
  referenciaDocumento: null,
  idDocumento: null,
  dataEnvio: null,
  documentoIncluidoComSucesso: false,
  documentoExcluidoComSucesso: false,
  erroInclusao: null,
};

export const carteiraDocumentosSlice = createSlice({
  name: 'carteiraDocumentos',
  initialState,
  reducers: {
    irParaSelecionarDocumento: (state, action: PayloadAction<{ integranteId: string; integranteNome: string; cpfIntegrante: string; tiposDocumentoExistentes: string[] }>) => {
      state.state = CarteiraDocumentosState.SELECIONAR_DOCUMENTO;
      state.integranteId = action.payload.integranteId;
      state.integranteNome = action.payload.integranteNome;
      state.cpfIntegrante = action.payload.cpfIntegrante;
      state.tiposDocumentoExistentes = action.payload.tiposDocumentoExistentes;
    },
    irParaUploadDocumento: (state, action: PayloadAction<{ tipoDocumento: string; nomeDocumento: string }>) => {
      state.state = CarteiraDocumentosState.UPLOAD_DOCUMENTO;
      state.tipoDocumento = action.payload.tipoDocumento;
      state.nomeDocumento = action.payload.nomeDocumento;
    },
    irParaPreviewImagem: (state, action: PayloadAction<{ imagemSrc: string; isPdf: boolean }>) => {
      state.state = CarteiraDocumentosState.PREVIEW_IMAGEM;
      state.imagemSrc = action.payload.imagemSrc;
      state.isPdf = action.payload.isPdf;
    },
    irParaVisualizarDocumento: (state, action: PayloadAction<{ integranteNome: string; tipoDocumento: string; nomeDocumento: string; dataEnvio: string; referenciaDocumento: string; idDocumento: number }>) => {
      state.state = CarteiraDocumentosState.VISUALIZAR_DOCUMENTO;
      state.integranteNome = action.payload.integranteNome;
      state.tipoDocumento = action.payload.tipoDocumento;
      state.nomeDocumento = action.payload.nomeDocumento;
      state.dataEnvio = action.payload.dataEnvio;
      state.referenciaDocumento = action.payload.referenciaDocumento;
      state.idDocumento = action.payload.idDocumento;
    },
    voltarParaLista: () => initialState,
    voltarParaListaComSucesso: () => ({ ...initialState, documentoIncluidoComSucesso: true }),
    voltarParaListaAposExclusao: () => ({ ...initialState, documentoExcluidoComSucesso: true }),
    limparSucesso: (state) => { state.documentoIncluidoComSucesso = false; },
    voltarParaSelecionarComErro: (state, action: PayloadAction<string>) => {
      state.state = CarteiraDocumentosState.SELECIONAR_DOCUMENTO;
      state.imagemSrc = null;
      state.isPdf = false;
      state.erroInclusao = action.payload;
    },
    limparErro: (state) => { state.erroInclusao = null; },
    voltarParaUpload: (state) => {
      state.state = CarteiraDocumentosState.UPLOAD_DOCUMENTO;
      state.imagemSrc = null;
      state.isPdf = false;
    },
    voltarParaSelecionar: (state) => {
      state.state = CarteiraDocumentosState.SELECIONAR_DOCUMENTO;
      state.tipoDocumento = null;
      state.nomeDocumento = null;
    },
  },
});

export const {
  irParaSelecionarDocumento,
  irParaUploadDocumento,
  irParaPreviewImagem,
  irParaVisualizarDocumento,
  voltarParaLista,
  voltarParaListaComSucesso,
  voltarParaListaAposExclusao,
  limparSucesso,
  voltarParaSelecionarComErro,
  limparErro,
  voltarParaUpload,
  voltarParaSelecionar,
} = carteiraDocumentosSlice.actions;

export const selectCarteiraDocumentosState = (state: RootState) => state.carteiraDocumentos.state;
export const selectCarteiraDocumentos = (state: RootState) => state.carteiraDocumentos;

export default carteiraDocumentosSlice.reducer;
